import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function initManifiesto() {
  const manifiestoText = document.querySelector(".manifiesto__text");

  if (!manifiestoText) return;

  const text = manifiestoText.textContent;
  const words = text.split(" ");

  manifiestoText.innerHTML = words
    .map(
      (word) =>
        `<span class="word" style="display: inline-block;">${word}</span>`,
    )
    .join(" ");

  // 🎯 ESTABLECER ESTADO INICIAL INMEDIATAMENTE
  gsap.set(".manifiesto__text .word", {
    filter: "blur(35px)",
    opacity: 0,
    scale: 1.4,
    y: 20,
  });

  // Luego animar con ScrollTrigger
  gsap.to(".manifiesto__text .word", {
    filter: "blur(0px)",
    opacity: 1,
    scale: 1,
    y: 0,
    duration: 1.5,
    stagger: 0.1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".manifiesto",
      start: "top 85%",
      end: "bottom 25%",
      scrub: 1.5,
      invalidateOnRefresh: true,
      // markers: true, // Quita esto cuando funcione
    },
  });

  // Refresh después de crear el ScrollTrigger
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);
}
